import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import classNames from 'classnames';
import styles from './styles.less';

export type InterestsViewProps = {
  interests: string;
};

export const InterestsView: FC<InterestsViewProps> = ({ interests }) => {
  const { t } = useTranslation();

  return (
    <Typography.Text
      className={classNames(!interests && styles['placeholder-text'])}
    >
      {interests || t('The employee has not yet written about his interests')}
    </Typography.Text>
  );
};
